import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PreferenceModel, UserNotificationPreference } from '../components/models/preference.model';
import { environment } from 'src/environments/environment';
import { PreferenceConfig } from '../preferences-config';

@Injectable({
  providedIn: 'root'
})
export class PreferenceService {

  constructor(private httpClient: HttpClient) { }
  getPreferenceV2(token: string): Observable<UserNotificationPreference> {
    return this.httpClient.get<UserNotificationPreference>(PreferenceConfig.getEmailPreferenceV2(token), this.getHttpOptionsV2());
  }
  setPreferenceV2(preferenceData: any) {
    return this.httpClient.post<UserNotificationPreference>(PreferenceConfig.setEmailPreferenceV2(), preferenceData, this.getHttpOptionsV2());
  }
  getPreference(token: string): Observable<PreferenceModel[]> {
    return this.httpClient.get<PreferenceModel[]>(PreferenceConfig.getEmailPreference(token), this.getHttpOptions());
  }
  setPreference(preferenceData: any) {
    return this.httpClient.post<PreferenceModel[]>(PreferenceConfig.setEmailPreference(), preferenceData, this.getHttpOptions());
  }
  getHttpOptionsV2() {
    const httpOptions = {
      headers: new HttpHeaders()
    };
    httpOptions.headers = httpOptions.headers.set('ApiName', 'CollaborationApi');
    if (environment.dynamicsettings["xVersion"]) {
      httpOptions.headers = httpOptions.headers.set('x-version', environment.dynamicsettings["xVersion"]);
    }
    return httpOptions;
  }
  getHttpOptions() {
    const httpOptions = {
      headers: new HttpHeaders()
    };
    httpOptions.headers = httpOptions.headers.set('ApiName', 'AlertApi');
    if (environment.dynamicsettings["xVersion"]) {
      httpOptions.headers = httpOptions.headers.set('x-version', environment.dynamicsettings["xVersion"]);
    }
    return httpOptions;
  }
  getMailReceivedResponse(url) {
    return this.httpClient.post<any>(url, {}, this.getHttpOptions());
  }
}
